import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Image = styled.img`
    margin-top: 40px;
    width: 100%;
    box-shadow: ${theme.shadow.medium};
    cursor: pointer;
`;
